import metadata from 'app/metadata.json'

export const getVersion = () => {
    return `${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision}`
}

export const getEnvironment = () => {
    return process.env.REACT_APP_ENV
}
